import React, { useState } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";

const ProjectList = () => {
  const [showSidebar, setShowSidebar] = useState(false);


  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };
  return (
    <div class="g-sidenav-show  bg-gray-100">
      <div id="wrapper">
        <Leftbar showSidebar={showSidebar}
          handleSidebarClose={handleSidebarClose} />
        <main className="main-content border-radius-lg">
          <Topbar handleSidebar={handleSidebar} />

          <div className="header header-bg pb-6">
            <div className="container-fluid">
              <div className="header-body">
                <div className="row align-items-center py-4">
                  <div className="col-lg-6 col-7">
                    <nav
                      aria-label="breadcrumb"
                      className="d-none d-md-inline-block ml-md-4"
                    >
                      <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                        <li className="breadcrumb-item">
                          <Link to="/dashboard">
                            <i className="fas fa-home" />
                          </Link>
                        </li>
                        <li className="breadcrumb-item mt-2">
                          <span className="" style={{ color: "#f6f9fc"}}>Projects</span>
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid mt--6">
            <div className="row">
              <div className="col">
                <div className="card">
                  <div className="card-header border-0">
                    <div className="row">
                      <div className="col-9">
                        <h5 className="mb-0">Project Listing </h5>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table align-items-center table-flush">
                      <thead className="thead-light">
                        <tr>
                          <th>Action</th>
                          <th>Project ID</th>
                          <th>Project Name</th>
                          <th>Created By</th>
                          <th>Assigned To</th>
                          <th>Client (Location)</th>
                          <th>Category</th>
                          <th>Start Date (Deadline)</th>
                          <th>Status</th>
                          <th>Interested User</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div style={{ width: "120px" }}>
                              <Link to={"/view-project/101"} target="_blank">
                                <button className="viewproject-btn pull-right mb-1">
                                  <span className="" style={{ color:"#292f36" }}>View Project</span>
                                </button>
                              </Link>
                            </div>
                          </td>

                          <td className="table-user">
                            <b>#101</b>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Company Website Revamp</b>
                              <span>Frontend + CMS</span>
                              <span>contact@clientcorp.com</span>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Vikash Jha</b>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Anjali Mehra</b>
                              <div>anjali.m@example.com</div>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "150px" }}>
                              <b>ClientCorp Ltd.</b>
                              <div className="text-muted">Mumbai, India</div>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">Corporate Website</span>
                              <span className="text-muted">React, WordPress</span>
                            </div>
                          </td>

                          <td>
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">2025-06-01</span><br />
                              <span className="text-muted">Deadline: 2025-07-15</span>
                            </div>
                          </td>
                          <td>
                            <div className="project-status p-1" style={{ width: "120px" }}>
                              <span className="text-white d-flex justify-content-center">Completed</span>
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">10</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}
export default ProjectList;